import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux';
import withAppShell from '../../../hoc/withAppShell/WithAppShell';
import { Grades } from '.';
import { AddGradeActions } from '../../../../store';
import { SchoolInformationActions } from '../../../../store'
import lodashUtil from 'lodash';
import { toast } from 'react-toastify';
import { SubjectContainer } from '../subject'
import * as StringReplacer from '../../../../i18n/StringReplacer'
import { updatingRulesUtil } from '../updatingRulesUtil';
import * as WeeklyCalendarUtil from '../weeklyCalendar/WeeklyCalendarUtil';
import { PreferredPeriodsUtil } from '../rules/dialog/preferredPeriod';
import spinner from "../../../ui/icons/spinner.gif";
import { MuiGrid } from '../../../ui';
import theme from '../../../../assests/theme'
import { saveSchoolConcurrently } from '../../../../utils/ConcurrentSchoolSaveUtil';
import { gradePickerUtil } from '../../gradePicker';
class AddGradeContainer extends Component {

  constructor(props) {

    let subjectList
    let electiveList
    let teacherList
    if (props.activeSchool.school_master !== undefined) {
      subjectList = JSON.parse(JSON.stringify(props.activeSchool.school_master.subjects))
      electiveList = JSON.parse(JSON.stringify(props.activeSchool.school_master.electives))
      teacherList = JSON.parse(JSON.stringify(props.activeSchool.school_master.teachers))

    }

    super(props);
    this.state = {
      gradelist: [],
      roomName: "",
      edit: false,
      isRequiredInfoAvailable: true,
      didSubjectUpdate: false,
      didElectiveUpdate: false,
      didTeacherUpdate: false,
      subjectList: subjectList,
      electiveList: electiveList,
      teacherList: teacherList,
      gradesArrayToRemoveInRules: [],
      reducedGroupNumberArray: [],
      addedGroupsNumberArray: [],
      confirmDialog: {
        isChanged: false,
        isSaved: false
      },
      toggle: false
    }
  }

  componentWillMount() {
    const i18n = this.props.i18n
    let gradeMasterData = this.props.getGradeMasterData();
    if (this.props.activeSchool.name === "" || this.props.activeSchool.name === undefined) {
      toast(i18n.toastMsgs.noDataInSchoolIndormationMsg)
      this.props.previousStep()
      this.setState({
        isRequiredInfoAvailable: false,
        gradeMasterData: gradeMasterData,
      })
    }
  }

  componentDidMount() {

    if (!lodashUtil.isEmpty(this.props.activeSchool.school_master)) {
      let gradeLevels = this.props.activeSchool.school_master.gradeLevels;
      let gradelist = this.destructuringOfGradeLevels(gradeLevels);
      this.setState({
        gradelist: gradelist
      })
    }
  }

  destructuringOfGradeLevels = (gradeLevels) => {
    let tempGradeList = []
    for (let i = 0; i < gradeLevels.length; i++) {
      let gradeLevel = {};
      gradeLevel = gradeLevels[i];
      for (let j = 0; j < gradeLevel.grades.length; j++) {
        let grade = {};
        grade.levelName = gradeLevel.levelName;
        grade.gradeName = gradeLevel.grades[j].gradeName;
        grade.numberOfGroups = gradeLevel.grades[j].numberOfGroups;
        grade.groups = gradeLevel.grades[j].groups;
        tempGradeList.push(grade);
      }
    }
    return tempGradeList;
  }

  constructGradeListToBeSend = (gradeList) => {
    let gradeLevels = [];
    let totalNumberOfGrades = gradeList.length;
    let totalNumberOfGroups = 0;
    for (let i = 0; i < gradeList.length; i++) {
      let gradeLevelIndex = lodashUtil.findIndex(gradeLevels, function (gradeLevel) { return gradeLevel.levelName == gradeList[i].levelName });
      if (gradeLevelIndex == -1) {
        let gradeLevel = {};
        gradeLevel.levelName = gradeList[i].levelName
        gradeLevel.grades = [];
        let grade = {};
        grade.gradeName = gradeList[i].gradeName;
        grade.numberOfGroups = gradeList[i].numberOfGroups
        totalNumberOfGroups += Number(grade.numberOfGroups)
        grade.groups = gradeList[i].groups
        gradeLevel.grades.push(grade)
        gradeLevels.push(gradeLevel);
      }
      else {
        let gradeLevel = gradeLevels[gradeLevelIndex];
        let grade = {};
        grade.gradeName = gradeList[i].gradeName;
        grade.numberOfGroups = gradeList[i].numberOfGroups
        totalNumberOfGroups += Number(grade.numberOfGroups)
        grade.groups = gradeList[i].groups;
        gradeLevel.grades.push(grade);
        gradeLevels[gradeLevelIndex] = gradeLevel;
      }
    }
    return { gradeLevels: gradeLevels, totalNumberOfGrades: totalNumberOfGrades, totalNumberOfGroups: totalNumberOfGroups };
  }

  modifingGradeLevelObjectInRules = (tempActiveSchool) => {
    let scheduleConstraints = tempActiveSchool.schedule_constraints;
    if (scheduleConstraints.length !== 0) {
      let constraintsArray = updatingRulesUtil.constraintsArray
      for (let i = 0; i < scheduleConstraints.length; i++) {
        let scheduleObj = scheduleConstraints[i]
        let isSCheduleUpdated = false;
        for (let j = 0; j < constraintsArray.length; j++) {
          let ruleName = constraintsArray[j]
          let ruleArray = scheduleObj[ruleName]
          if (ruleArray.length > 0) {
            for (let k = 0; k < ruleArray.length; k++) {
              let levelName = gradePickerUtil.getGradeLevelByGrade(tempActiveSchool.school_master.gradeLevels, ruleArray[k].gradeDetails.grades[0].grade)
              if (ruleArray[k].gradeDetails.gradeLevels[0].level !== levelName) {
                ruleArray[k].gradeDetails.gradeLevels[0].level = levelName;
                if (scheduleObj.status === 'Completed') {
                  ruleArray[k].isDirty = true;
                }
                let isSCheduleUpdated = true;
              }
            }
          }
        }
        if (isSCheduleUpdated === true) {
          scheduleObj.version = scheduleObj.version + 1
        }
      }
    }
  }

  onClickOfSave = async () => {
    let incompleteData = false;
    let gradelist = this.state.gradelist
    const i18n = this.props.i18n
    for (let i = 0; i < gradelist.length; i++) {
      let array = gradelist[i]
      if (array.gradeName === undefined
        || array.groups.length === 0
        || array.numberOfGroups === undefined
        || array.gradeName.trim() === "") {

        toast(i18n.grades.fieldsAreEmpty);
        incompleteData = true;
        break;
      } else {
        let repeatingGrade = lodashUtil.filter(gradelist, ['gradeName', gradelist[i].gradeName]);
        if (repeatingGrade.length > 1) {
          let errorMessage_repeatingGradeName = StringReplacer.getFormatedMessage(i18n.grades.repeatingGradeName,
            {
              GradeName: gradelist[i].gradeName,
            })
          toast(errorMessage_repeatingGradeName);
          incompleteData = true;
          break;
        }
      }
    }

    if (incompleteData === false) {

      let tempActiveSchool = JSON.parse(JSON.stringify(this.props.activeSchool))
      if (tempActiveSchool.schedule_constraints.length > 0) {
        if (this.state.gradesArrayToRemoveInRules.length > 0) {
          this.gradeUpdatingMethod(tempActiveSchool);
        }
        if (this.state.reducedGroupNumberArray.length > 0) {
          this.reducedGroupsMethod(tempActiveSchool);
        }
        if (this.state.addedGroupsNumberArray.length > 0) {
          this.addedGroupsMethod(tempActiveSchool);
        }

      }

      gradelist = this.sortingOfGrades();
      let gradeListToBeSend = this.constructGradeListToBeSend(gradelist)
      tempActiveSchool.school_master.gradeLevels = gradeListToBeSend.gradeLevels
      tempActiveSchool.school_master.totalNumberOfGrades = gradeListToBeSend.totalNumberOfGrades
      tempActiveSchool.school_master.totalNumberOfGroups = gradeListToBeSend.totalNumberOfGroups
      if (tempActiveSchool.schedule_constraints.length > 0) {
        this.modifingGradeLevelObjectInRules(tempActiveSchool)
      }
      if (this.state.didSubjectUpdate === true) {
        tempActiveSchool.school_master.subjects = this.state.subjectList;
        tempActiveSchool.school_master.modifiedDate = new Date()
      }
      if (this.state.didElectiveUpdate === true) {
        tempActiveSchool.school_master.electives = this.state.electiveList;
        tempActiveSchool.school_master.modifiedDate = new Date()
      }
      if (this.state.didTeacherUpdate === true) {
        tempActiveSchool.school_master.teachers = this.state.teacherList;
        tempActiveSchool.school_master.modifiedDate = new Date()
      }
      //await this.props.editSchoolInformation(this.props.userInformation._id, this.props.activeSchool._id, tempActiveSchool)

      //toast(i18n.toastMsgs.gradesSavedSuccessfully);

      let result = await saveSchoolConcurrently(this.props.editSchoolInformation,
        this.props.userInformation._id,
        this.props.activeSchool._id,
        tempActiveSchool,
        i18n.toastMsgs.gradesSavedSuccessfully);


      this.setState({
        toggle: !this.state.toggle,
        confirmDialog: {
          isChanged: false,
        }
      })
    }
  }

  gradeUpdatingMethod = (tempActiveSchool) => {
    this.deletingGradeObjectInRules(tempActiveSchool);
    this.updateCalendarGrade(tempActiveSchool);
    this.updatingThePeridosWhenGradeIsDeleted(tempActiveSchool)
  }

  reducedGroupsMethod = (tempActiveSchool) => {
    this.removingRulesDataWhenSectionsAreReduced(tempActiveSchool);
    this.updatingThePeridosWhenGropusAreReduced(tempActiveSchool);
    this.setState({
      confirmDialog: {
        isChanged: true
      },
    })
  }

  addedGroupsMethod = (tempActiveSchool) => {
    this.addingRulesDataWhenSectionsAreAdded(tempActiveSchool)
    this.setState({
      confirmDialog: {
        isChanged: true
      },
    })
  }


  removeGradeFromGradeList = (key) => {
    let gradelist = this.state.gradelist
    let removedGrade = gradelist.splice(key, 1)
    removedGrade = removedGrade[0];
    let gradesArrayToRemoveInRules = JSON.parse(JSON.stringify(this.state.gradesArrayToRemoveInRules))
    gradesArrayToRemoveInRules.push(removedGrade);

    let deleteGradeLevel = false;
    let isGradeLevelPresent = lodashUtil.find(gradelist, ["levelName", removedGrade.levelName]);
    if (isGradeLevelPresent === undefined) {
      deleteGradeLevel = true
    }

    this.updatingSubjectArray(removedGrade, deleteGradeLevel);
    this.updatingElectiveArray(removedGrade, deleteGradeLevel)
    this.updatingTeacherArray(removedGrade, deleteGradeLevel);
    this.setState({
      confirmDialog: {
        isChanged: true
      },
      gradelist: gradelist,
      gradesArrayToRemoveInRules: gradesArrayToRemoveInRules
    })
  }

  updatingSubjectArray = (removedGrade, deleteGradeLevel) => {
    let subjectList = JSON.parse(JSON.stringify(this.state.subjectList));
    subjectList = this.modifyingGradeDetail(removedGrade, subjectList, deleteGradeLevel)
    this.setState({
      subjectList: subjectList,
      didSubjectUpdate: true
    })
  }

  updatingElectiveArray = (removedGrade, deleteGradeLevel) => {
    let electviesList = this.state.electiveList;
    electviesList = this.modifyingGradeDetail(removedGrade, electviesList, deleteGradeLevel);
    this.setState({
      electiveList: electviesList,
      didElectiveUpdate: true
    });
  }

  updatingTeacherArray = (removedGrade, deleteGradeLevel) => {
    let teachersArray = this.state.teacherList;
    for (let i = 0; i < teachersArray.length; i++) {
      let assignedSubjectArray = teachersArray[i].assignedSubjects;
      assignedSubjectArray = this.modifyingGradeDetail(removedGrade, assignedSubjectArray, deleteGradeLevel);
    }
    this.setState({
      teacherList: teachersArray,
      didTeacherUpdate: true
    })
  }

  /**
   * this method takes in the removed grade and the subject or elective or teachers assigned subject list
   * (Example - gradeLevel: Elementary, grade: 1)if only grade is being deleted and there are more gradeLevel: Elementary then delete only that grade in GRADES.
   * if thats the last Elementary object in the list then search in gradeLevels and delete the Elementary. 
   */
  modifyingGradeDetail = (removedGrade, updatingListArray, deleteGradeLevel) => {
    for (let i = 0; i < updatingListArray.length; i++) {
      let gradeDetails = updatingListArray[i].gradeDetails;
      if (gradeDetails.grades.length != 0) {
        let gradeIndex = lodashUtil.findIndex(gradeDetails.grades, ["grade", removedGrade.gradeName]);
        if (gradeIndex != -1) {
          gradeDetails.grades.splice(gradeIndex, 1);
          if (gradeDetails.grades.length === 0 && gradeDetails.gradeLevels.length === 0) {
            updatingListArray.splice(i, 1);
            i -= 1;
          }
        }
      }
      if (deleteGradeLevel === true) {
        if (gradeDetails.gradeLevels.length != 0) {
          let gradeLevelIndex = lodashUtil.findIndex(gradeDetails.gradeLevels, ["level", removedGrade.levelName]);
          if (gradeLevelIndex != -1) {
            gradeDetails.gradeLevels.splice(gradeLevelIndex, 1);
            if (gradeDetails.gradeLevels.length === 0
              && gradeDetails.grades.length === 0) {
              updatingListArray.splice(i, 1);
              i -= 1
            }
          }
        }
      }
    }

    return updatingListArray
  }

  handleOnChange = (name, value, index) => {
    let gradelist = this.state.gradelist
    gradelist[index][name] = value

    this.setState({
      gradelist: gradelist,
      confirmDialog: {
        isChanged: true
      }
    })

  }



  renderAddRow = () => {
    let gradeList = this.state.gradelist;
    let gradeMasterData = this.props.gradeMasterData;
    let gradeName;
    let levelName;
    let numberOfGroups;
    let groups;

    if (gradeList.length < 1) {
      gradeName = gradeMasterData.gradeNumber[0];
      levelName = gradeMasterData.gradeLevel[0];
      numberOfGroups = gradeMasterData.numberOfGroups[0];
      groups = this.calculateGroupsAndRoomName(numberOfGroups, gradeName);
    } else {

      let previousGradeNameIndex = lodashUtil.indexOf(gradeMasterData.gradeNumber, gradeList[gradeList.length - 1].gradeName);
      gradeName = gradeMasterData.gradeNumber[previousGradeNameIndex + 1];
      levelName = gradeList[gradeList.length - 1].levelName;
      numberOfGroups = gradeList[gradeList.length - 1].numberOfGroups;
      groups = this.calculateGroupsAndRoomName(numberOfGroups, gradeName);
    }

    let activeGrade = {
      id: gradeList.length + 1,
      gradeName: gradeName,
      levelName: levelName,
      numberOfGroups: numberOfGroups,
      groups: groups,

      // DO WE NEED GROUP_NAME AND ROOM_NAME? 
    }

    gradeList.push(activeGrade)
    this.setState({
      gradelist: gradeList,
      activeGrade: activeGrade
    })
  }

  calculateGroupsAndRoomName = (value, gradeName) => {
    let groupNames = this.props.gradeMasterData.grades.slice(0, Number(value))
    let groups = []
    groupNames.map(element => {
      let group = {}
      group.groupName = element;
      group.roomName = gradeName + "-" + element
      groups.push(group)
    });
    this.setState({
      toggle: !this.state.toggle
    })
    return groups;
  }

  sortingOfGrades = () => {
    let master_gradeLevel = this.props.gradeMasterData.gradeLevel;
    let master_gradeNumber = this.props.gradeMasterData.gradeNumber;
    let gradelist = this.state.gradelist
    let tempGradeList = [];

    for (let a = 0; a < master_gradeLevel.length; a++) {
      let levelName = master_gradeLevel[a];

      // getting all the LEVELS
      let levelObjects = lodashUtil.filter(gradelist, ["levelName", levelName]);
      if (levelObjects.length > 0) {
        let levelObjCount = levelObjects.length;
        let objCount = 0;
        for (let b = 0; b < master_gradeNumber.length; b++) {
          let gradeName = master_gradeNumber[b];

          // pushing of GRADE
          let isGradePresent = lodashUtil.find(levelObjects, ["gradeName", gradeName])
          if (isGradePresent !== undefined) {
            objCount++
            tempGradeList.push(isGradePresent);
          }
          if (levelObjCount === objCount) {
            break;
          }
        }
      }
    }
    this.setState({ gradelist: tempGradeList })
    return tempGradeList
  }

  modifyingSubjectArray = (updatedGroups, gradeName) => {
    let subjectList = this.state.subjectList
    subjectList = this.modifyingGroups(updatedGroups, gradeName, subjectList)
    this.setState({
      subjectList: subjectList,
      didSubjectUpdate: true
    })
  }

  modifyingElectiveArray = (updatedGroups, gradeName) => {
    let electiveList = this.state.electiveList
    electiveList = this.modifyingGroups(updatedGroups, gradeName, electiveList)
    this.setState({
      electiveList: electiveList,
      didElectiveUpdate: true
    })
  }

  modifyingTeacherArray = (updatedGroups, gradeName) => {
    let teacherList = this.state.teacherList
    for (let x = 0; x < teacherList.length; x++) {
      let assignedSubjectArray = teacherList[x].assignedSubjects;
      assignedSubjectArray = this.modifyingGroups(updatedGroups, gradeName, assignedSubjectArray)
    }
    this.setState({
      teacherList: teacherList,
      didSubjectUpdate: true
    })
  }

  /**
   * this method takes in the updated groups (example - 1 had 3 sections but now that is changed to 2 sections) 
   * finding if the saved gradeDetail either in subjects, electives or teachers assigned subjects has the group which is not present in the updated groups and removing them.
   */
  modifyingGroups = (updatedGroups, gradeName, arrayList) => {
    for (let i = 0; i < arrayList.length; i++) {
      let gradeDetails = arrayList[i].gradeDetails
      if (gradeDetails.grades.length != 0) {
        let gradeObj = lodashUtil.find(gradeDetails.grades, ["grade", gradeName]);
        if (gradeObj != undefined) {
          for (let j = 0; j < gradeObj.groups.length; j++) {
            let groupObj = gradeObj.groups[j];
            let isGroupPresent = lodashUtil.find(updatedGroups, ["groupName", groupObj.groupCode]);
            if (isGroupPresent === undefined) {
              gradeObj.groups.splice(j, 1)
              j -= 1;

            }
          }
        }
      }
    }
    return arrayList;
  }

  showContextualHelp = (props, event) => {
    let content = props.contextualHelp["grades"];
    if (content !== undefined) {
      props.toggleDrawer("right", true, content)(event)
    }
  }

  deletingGradeObjectInRules = (tempActiveSchool) => {
    // tempActiveSchool reference is taken hence no need to save separately.
    let scheduleConstraints = tempActiveSchool.schedule_constraints;
    if (scheduleConstraints.length !== 0) {
      let constraintsArray = updatingRulesUtil.constraintsArray

      let gradesArrayToRemoveInRules = this.state.gradesArrayToRemoveInRules

      for (let i = 0; i < scheduleConstraints.length; i++) {
        let scheduleObj = scheduleConstraints[i]
        let isSCheduleUpdated = false;
        // RULES ARRAY  
        for (let j = 0; j < constraintsArray.length; j++) {
          let ruleName = constraintsArray[j]
          let ruleArray = scheduleObj[ruleName]
          if (ruleArray.length > 0) {

            // ONE RULE 
            for (let k = 0; k < ruleArray.length; k++) {
              if (ruleName !== "jointClasses") {
                let gradeName = ruleArray[k].gradeDetails.grades[0].grade
                let gradePresent = lodashUtil.find(gradesArrayToRemoveInRules, ["gradeName", gradeName])
                if (gradePresent !== undefined) {
                  ruleArray.splice(k, 1)
                  k -= 1;
                  isSCheduleUpdated = true
                }
              }
              //JOINT CLASSES
              else {
                let gradeArray = ruleArray[k].gradeDetails.grades
                for (let l = 0; l < gradeArray.length; l++) {
                  let nameOfTheGrade = gradeArray[l].grade
                  let gradeObjPresent = lodashUtil.find(gradesArrayToRemoveInRules, ["gradeName", nameOfTheGrade])
                  if (gradeObjPresent !== undefined) {
                    gradeArray.splice(l, 1)
                    if (gradeArray.length === 0) {
                      ruleArray.splice(k, 1)
                      k -= 1;
                      isSCheduleUpdated = true
                    }
                  }
                }
              }
            }
          }
        }
        if (isSCheduleUpdated === true) {
          scheduleObj.version = scheduleObj.version + 1
        }
      }
    }
  }

  whenNumberOfGroupsReduced = (gradeName, groupArray) => {
    let reducedGroupNumberArray = this.state.reducedGroupNumberArray
    for (let a = 0; a < groupArray.length; a++) {
      let tempObj = {}
      tempObj.gradeName = gradeName
      tempObj.groupName = groupArray[a].groupName
      reducedGroupNumberArray.push(JSON.parse(JSON.stringify(tempObj)))
    }
    this.setState({
      reducedGroupNumberArray: reducedGroupNumberArray,
      confirmDialog: {
        isChanged: true
      }
    })
  }

  whenNumberOfGroupsAdded = (gradeName, groupArray) => {
    let addedGroupsNumberArray = this.state.addedGroupsNumberArray
    for (let a = 0; a < groupArray.length; a++) {
      let tempObj = {}
      tempObj.gradeName = gradeName
      tempObj.groupName = groupArray[a].groupName
      addedGroupsNumberArray.push(JSON.parse(JSON.stringify(tempObj)))
    }
    this.setState({
      addedGroupsNumberArray: addedGroupsNumberArray,
      confirmDialog: {
        isChanged: true
      }
    })
  }

  removingRulesDataWhenSectionsAreReduced = (tempActiveSchool) => {
    let scheduleConstraintsArray = tempActiveSchool.schedule_constraints;
    if (scheduleConstraintsArray.length != 0) {
      let constraintsArray = updatingRulesUtil.constraintsArray
      let reducedGroupNumberArray = this.state.reducedGroupNumberArray

      for (let i = 0; i < scheduleConstraintsArray.length; i++) {
        let scheduleObj = scheduleConstraintsArray[i]
        let isSCheduleUpdated = false;
        // RULES ARRAY  
        for (let j = 0; j < constraintsArray.length; j++) {
          let ruleName = constraintsArray[j]
          let ruleArray = scheduleObj[ruleName]
          if (ruleArray.length > 0) {

            // ONE RULE 
            for (let k = 0; k < ruleArray.length; k++) {
              if (ruleName !== "jointClasses") {
                let gradeObj = ruleArray[k].gradeDetails.grades[0]
                let gradeName = gradeObj.grade
                if (gradeObj.groups.length !== 0) {
                  let groupName = gradeObj.groups[0].groupCode
                  let gradePresent = lodashUtil.filter(reducedGroupNumberArray, ["gradeName", gradeName])
                  if (gradePresent.length !== 0) {
                    let groupPresent = lodashUtil.find(gradePresent, ["groupName", groupName])
                    if (groupPresent !== undefined) {
                      if (scheduleObj.status !== 'Completed') {
                        ruleArray.splice(k, 1)
                        k -= 1;
                        isSCheduleUpdated = true
                      } else {
                        ruleArray.isDirty = true
                        isSCheduleUpdated = true
                      }
                    }
                  }
                }
              }
              //JOINT CLASSES
              else {
                let gradeArray = ruleArray[k].gradeDetails.grades
                for (let l = 0; l < gradeArray.length; l++) {
                  let gradeObject = gradeArray[l]
                  let nameOfTheGrade = gradeObject.grade
                  let gradeObjPresent = lodashUtil.find(reducedGroupNumberArray, ["gradeName", nameOfTheGrade])
                  if (gradeObjPresent !== undefined) {
                    let groupCodePresentIndex = lodashUtil.findIndex(gradeObject.groups, ["groupCode", gradeObjPresent.groupName])

                    //if groups length is 0 then remove grade
                    if (groupCodePresentIndex !== -1) {
                      gradeObject.groups.splice(groupCodePresentIndex, 1)

                      //if grade object has no groups in it. we have to remove the grade object 
                      if (gradeObject.groups.length === 0) {
                        gradeArray.splice(l, 1)
                      }
                      else if (gradeObject.groups.length < 2) {
                        if (gradeArray.length < 2) {
                          if (scheduleObj.status !== 'Completed') {
                            ruleArray.splice(k, 1)
                            k -= 1;
                            isSCheduleUpdated = true
                          } else {
                            ruleArray.isDirty = true
                            isSCheduleUpdated = true
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        if (isSCheduleUpdated === true) {
          scheduleObj.version = scheduleObj.version + 1
        }
      }
    }
  }

  addingRulesDataWhenSectionsAreAdded = (tempActiveSchool) => {
    let scheduleConstraintsArray = tempActiveSchool.schedule_constraints;
    let constraintsArray = updatingRulesUtil.constraintsArray;

    let addedGroupsNumberArray = this.state.addedGroupsNumberArray;

    for (let i = 0; i < scheduleConstraintsArray.length; i++) {
      let scheduleObj = scheduleConstraintsArray[i]
      let isSCheduleUpdated = false;
      // RULES ARRAY  
      for (let j = 0; j < constraintsArray.length; j++) {
        let ruleName = constraintsArray[j]
        let ruleArray = scheduleObj[ruleName]
        let tempConstraintArray = [];
        if (ruleArray.length > 0) {
          // GROUPS ADDED ARRAY
          for (let k = 0; k < addedGroupsNumberArray.length; k++) {
            let groupsAddedObj = addedGroupsNumberArray[k]

            //ONE RULE 
            for (let l = 0; l < ruleArray.length; l++) {
              // if it is other than joint class constaraint
              let ruleObject = ruleArray[l]
              if (ruleName !== "jointClasses") {
                if (ruleObject.gradeDetails.grades[0].grade === groupsAddedObj.gradeName
                  && ruleObject.gradeDetails.grades[0].groups.length === 0) {
                  let tempObj = JSON.parse(JSON.stringify(ruleObject))
                  delete tempObj._id
                  tempObj.gradeDetails.grades[0].groups.push({ groupCode: groupsAddedObj.groupName });
                  if (scheduleObj.status === 'Completed') {
                    tempObj.isDirty = true;
                  }
                  tempConstraintArray.push(tempObj)
                  isSCheduleUpdated = true
                }
              }
              // if it is joint class constraint
              else {
                for (let m = 0; m < ruleObject.gradeDetails.grades.length; m++) {
                  let gradeObj = ruleObject.gradeDetails.grades[m]
                  if (gradeObj.grade === groupsAddedObj.gradeName) {
                    let gradeLevels = tempActiveSchool.school_master.gradeLevels;
                    for (let q = 0; q < gradeLevels.length; q++) {
                      let levelObj = gradeLevels[q]
                      let findGradeObj = lodashUtil.find(levelObj.grades, ["gradeName", groupsAddedObj.gradeName]);

                      if (findGradeObj !== undefined) {
                        if (findGradeObj.numberOfGroups <= gradeObj.groups.length) {
                          gradeObj.groups.push({ groupCode: groupsAddedObj.groupName })
                          if (scheduleObj.status === 'Completed') {
                            ruleObject.isDirty = true;
                          }
                          isSCheduleUpdated = true
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        let tempRuleArray = ruleArray.concat(tempConstraintArray);
        scheduleObj[ruleName] = JSON.parse(JSON.stringify(tempRuleArray))
      }
      if (isSCheduleUpdated === true) {
        scheduleObj.version = scheduleObj.version + 1
      }
    }
  }

  updateCalendarGrade = (tempActiveSchool) => {
    // tempActiveSchool reference is taken hence no need to save it seperately.
    let scheduleConstraintArray = tempActiveSchool.schedule_constraints
    if (scheduleConstraintArray.length > 0) {
      let levelArray = [];
      let gradesArrayToRemoveInRules = this.state.gradesArrayToRemoveInRules;
      let reducedGroupNumberArray = this.state.reducedGroupNumberArray;

      for (let i = 0; i < scheduleConstraintArray.length; i++) {
        let weeklyCalendarObj = scheduleConstraintArray[i].weeklyCalendar;
        let isSCheduleUpdated = false;
        for (let v = 0; v < weeklyCalendarObj.length; v++) {
          let weeklyCal_GradeDetails = weeklyCalendarObj[v].gradeDetails;

          // if GRADE is deleted
          if (gradesArrayToRemoveInRules.length > 0) {
            levelArray = this.gradesCheckIfGradeLevelIsDeleted(gradesArrayToRemoveInRules)

            if (weeklyCal_GradeDetails.grades.length > 0) {
              for (let j = 0; j < weeklyCal_GradeDetails.grades.length; j++) {
                let grade = weeklyCal_GradeDetails.grades[j];
                let isGradePresent = lodashUtil.find(gradesArrayToRemoveInRules, ["gradeName", grade.grade])
                if (isGradePresent !== undefined) {
                  weeklyCal_GradeDetails.grades.splice(j, 1)
                  j -= 1;
                  isSCheduleUpdated = true;
                }
              }
            }

            // if all grades from the gradeLevel is removed 
            if (levelArray.length > 0) {
              for (let k = 0; k < weeklyCal_GradeDetails.gradeLevels.length; k++) {
                let gradeLevelObj = weeklyCal_GradeDetails.gradeLevels[k];
                if (levelArray.includes(gradeLevelObj.levelName)) {
                  weeklyCal_GradeDetails.gradeLevels.splice(k, 1)
                  k -= 1;
                  isSCheduleUpdated = true;
                }
              }
            }
          }
        }
        if (isSCheduleUpdated === true) {
          scheduleConstraintArray[i].version = scheduleConstraintArray[i].version + 1
        }
      }
    }
  }

  gradesCheckIfGradeLevelIsDeleted = (gradesArrayToRemoveInRules) => {
    let tempLevelArray = []
    let gradeLevels = this.props.activeSchool.school_master.gradeLevels
    for (let x = 0; x < gradeLevels.length; x++) {
      let gradeLevelObj = gradeLevels[x]
      let levelName = gradeLevelObj.levelName
      let levelArray = lodashUtil.filter(gradesArrayToRemoveInRules, ["levelName", levelName]);
      if (levelArray.length === gradeLevelObj.grades.length) {
        tempLevelArray.push(levelName);
      }
    }
    return tempLevelArray
  }

  updatingThePeridosWhenGradeIsDeleted = (tempActiveSchool) => {
    let periodNumberAltered = false;
    let scheduleConstraintArray = tempActiveSchool.schedule_constraints
    if (scheduleConstraintArray.length > 0) {
      for (let i = 0; i < scheduleConstraintArray.length; i++) {
        let isSCheduleUpdated = false;
        let weeklyCalendarArray = scheduleConstraintArray[i].weeklyCalendar;
        let gradesArrayToRemoveInRules = this.state.gradesArrayToRemoveInRules;
        let levelArray = this.gradesCheckIfGradeLevelIsDeleted(gradesArrayToRemoveInRules)
        for (let f = 0; f < weeklyCalendarArray.length; f++) {
          let weeklyCalObj = weeklyCalendarArray[f]
          let periodsArray = weeklyCalObj.periodsDetails

          for (let g = 0; g < periodsArray.length; g++) {
            let dayPeriodArray = periodsArray[g].periods

            for (let h = 0; h < dayPeriodArray.length; h++) {
              let periodGradeDetail = dayPeriodArray[h].gradeDetails

              //GRADE LEVEL 
              if (periodGradeDetail.gradeLevels.length > 0) {
                for (let m = 0; m < periodGradeDetail.gradeLevels.length; m++) {
                  let levelName = periodGradeDetail.gradeLevels[m].level
                  if (levelArray.includes(levelName)) {
                    periodGradeDetail.gradeLevels.splice(m, 1);
                    m -= 1;
                    if (periodGradeDetail.gradeLevels.length === 0 && periodGradeDetail.grades.length === 0) {
                      dayPeriodArray.splice(h, 1)
                      periodNumberAltered = true
                      h -= 1;
                      isSCheduleUpdated = true
                    }
                  }
                }
              }
              // GRADES
              if (periodGradeDetail.grades.length > 0) {
                let gradesArray = periodGradeDetail.grades
                for (let z = 0; z < gradesArray.length; z++) {
                  let gradeObj = gradesArray[z]
                  let isGradePresentINGradeObj = lodashUtil.find(gradesArrayToRemoveInRules, ["gradeName", gradeObj.grade])
                  if (isGradePresentINGradeObj != undefined) {

                    gradesArray.splice(z, 1)
                    if (gradesArray.length === 0 && periodGradeDetail.gradeLevels.length === 0) {
                      dayPeriodArray.splice(h, 1);
                      periodNumberAltered = true
                      h -= 1;
                      if (dayPeriodArray.length === 0) {
                        periodsArray.splice(g, 1)
                        g -= 1;
                        isSCheduleUpdated = true
                      }
                    }

                  }
                }
              }
            }

          }
          // renaming periods if the periods are deleted
          if (periodNumberAltered === true) {
            for (let t = 0; t < periodsArray.length; t++) {
              let oneDayObj = periodsArray[t]
              oneDayObj = WeeklyCalendarUtil.periodNaming(oneDayObj)
            }

            let tempObjForCalculateTotalPeriods = WeeklyCalendarUtil.calculateTotalPeriods(weeklyCalObj)
            weeklyCalObj.totalPeriods = tempObjForCalculateTotalPeriods.totalPeriods
            weeklyCalObj.startHourSlot = tempObjForCalculateTotalPeriods.startHourSlot
            weeklyCalObj.lastHourSlot = tempObjForCalculateTotalPeriods.lastHourSlot

            let workingDaysString = WeeklyCalendarUtil.calculateNumberOfDays(weeklyCalObj)
            weeklyCalObj.workingDays = workingDaysString

            this.modifyPreferredPeriodsRule(periodsArray, scheduleConstraintArray[i].preferredPeriods, scheduleConstraintArray[i])
          }
        }
        if (isSCheduleUpdated === true) {
          scheduleConstraintArray[i].version = scheduleConstraintArray[i].version + 1
        }
      }
    }
  }

  updatingThePeridosWhenGropusAreReduced = (tempActiveSchool) => {
    let periodNumberAltered = false;
    let scheduleConstraintArray = tempActiveSchool.schedule_constraints;
    if (scheduleConstraintArray.length > 0) {
      for (let i = 0; i < scheduleConstraintArray.length; i++) {
        let isSCheduleUpdated = false;
        let weeklyCalendarObj = scheduleConstraintArray[i].weeklyCalendar;
        let reducedGroupNumberArray = this.state.reducedGroupNumberArray;
        for (let f = 0; f < weeklyCalendarObj.length; f++) {
          let periodsArray = weeklyCalendarObj[f].periodsDetails
          for (let g = 0; g < periodsArray.length; g++) {
            let dayPeriodArray = periodsArray[g].periods

            for (let h = 0; h < dayPeriodArray.length; h++) {
              let periodGradeDetail = dayPeriodArray[h].gradeDetails

              //GRADES
              if (periodGradeDetail.grades.length > 0) {
                let gradesArray = periodGradeDetail.grades
                for (let z = 0; z < gradesArray.length; z++) {
                  let gradeObj = gradesArray[z]
                  let isGradePresentINGradeObj = lodashUtil.find(reducedGroupNumberArray, ["gradeName", gradeObj.grade])
                  if (isGradePresentINGradeObj != undefined) {
                    if (gradeObj.groups.length > 0) {

                      let groupsPresentIndex = lodashUtil.findIndex(gradeObj.groups, ["groupCode", isGradePresentINGradeObj.groupName]);
                      if (groupsPresentIndex !== -1) {
                        gradeObj.groups.splice(groupsPresentIndex, 1)
                        if (gradeObj.groups.length === 0) {
                          gradesArray.splice(z, 1)
                          if (gradesArray.length === 0) {
                            if (periodGradeDetail.gradeLevels.length === 0) {
                              dayPeriodArray.splice(h, 1)
                              h -= 1;
                              periodNumberAltered = true;
                            }

                          }
                        }
                        isSCheduleUpdated = true
                      }
                    }
                  }

                }
              }
            }
          }
          if (periodNumberAltered === true) {
            for (let t = 0; t < periodsArray.length; t++) {
              let oneDayObj = periodsArray[t]
              oneDayObj = WeeklyCalendarUtil.periodNaming(oneDayObj)
            }
            this.modifyPreferredPeriodsRule(periodsArray, scheduleConstraintArray[i].preferredPeriods, scheduleConstraintArray[i])
          }
        }
        if (isSCheduleUpdated === true) {
          scheduleConstraintArray[i].version = scheduleConstraintArray[i].version + 1
        }
      }
    }
  }

  modifyPreferredPeriodsRule = (periodsDetails, preferredPeriods, scheduleObj) => {
    let isSCheduleUpdated = false;
    let periodsArrayToDisplay = []
    let preferredPeriodsArray = preferredPeriods
    if (preferredPeriodsArray.length > 0) {
      periodsArrayToDisplay = PreferredPeriodsUtil.getPeriodNameArray(periodsDetails)
    }

    for (let n = 0; n < preferredPeriodsArray.length; n++) {
      let preferredPeriodObj = preferredPeriodsArray[n]
      for (let p = 0; p < preferredPeriodObj.preferences.length; p++) {
        let preferencesObj = preferredPeriodObj.preferences[p]
        //AFTER
        if (preferencesObj.after !== "") {
          if (!periodsArrayToDisplay.includes(preferencesObj.after)) {

            if (scheduleObj.status !== 'Completed') {
              preferredPeriodObj.preferences.splice(p, 1)
              p -= 1
              isSCheduleUpdated = true;
              preferredPeriodObj.isDirty = true
            } else {
              isSCheduleUpdated = true;
              preferredPeriodObj.isDirty = true
            }
            if (preferredPeriodObj.preferences.length === 0) {
              if (scheduleObj.status !== 'Completed') {
                preferredPeriodsArray.splice(n, 1)
                n -= 1
                isSCheduleUpdated = true
              } else {
                isSCheduleUpdated = true;
                preferredPeriodsArray[n].isDirty = true
              }
            }
          }
        }

        //BEFORE
        if (preferencesObj.before !== "") {
          if (!periodsArrayToDisplay.includes(preferencesObj.before)) {
            if (scheduleObj.status !== 'Completed') {
              preferredPeriodObj.preferences.splice(p, 1)
              p -= 1
              isSCheduleUpdated = true
              preferredPeriodObj.isDirty = true
            } else {
              isSCheduleUpdated = true;
              preferredPeriodObj.isDirty = true;
            }
            if (preferredPeriodObj.preferences.length === 0) {
              if (scheduleObj.status !== 'Completed') {
                if (scheduleObj.status !== 'Completed') {
                  preferredPeriodsArray.splice(n, 1)
                  n -= 1
                  isSCheduleUpdated = true
                } else {
                  isSCheduleUpdated = true;
                  preferredPeriodsArray[n].isDirty = true
                }
              }
            }
          }
        }
      }
      if (isSCheduleUpdated === true) {
        scheduleObj.version = scheduleObj.version + 1
      }
    }
  }
  componentWillUnmount() {
    if (this.state.confirmDialog.isChanged) {
      this.beforeUnload()
    }
  }

  undoChanges = () => {
    this.setState({
      confirmDialog: { isChanged: false }
    })
  }
  beforeUnload = async () => {
    const i18n = this.props.i18n
    var flag = window.confirm(i18n.grades.msgForUnsavedChangesInTab);
    if (flag) {
      await this.onClickOfSave()
    }
    else {
      await this.undoChanges()
    }
  }

  render() {
    if (this.props.activeSchool.school_master == undefined) {
      return <MuiGrid container xs={12} alignItems="stretch" justify='center' alignContent='center' direction='column' >
        <img src={spinner} alt="none" style={theme.spinnerImgStyle} /></MuiGrid>
    }
    return <Fragment>
      {this.state.isRequiredInfoAvailable ?
        <Grades
          {...this.props}
          {...this.state}
          onClickOfSave={this.onClickOfSave}
          testGrade={this.testGrade}
          handleOnChange={this.handleOnChange}
          fetchGradeList={this.fetchGradeList}
          removeGradeFromGradeList={this.removeGradeFromGradeList}
          renderAddRow={this.renderAddRow}
          modifyingSubjectArray={this.modifyingSubjectArray}
          modifyingElectiveArray={this.modifyingElectiveArray}
          modifyingTeacherArray={this.modifyingTeacherArray}
          showContextualHelp={this.showContextualHelp}
          whenNumberOfGroupsReduced={this.whenNumberOfGroupsReduced}
          whenNumberOfGroupsAdded={this.whenNumberOfGroupsAdded}
          beforeUnload={this.beforeUnload}
        />
        :
        null}
    </Fragment>
  }
}

const mapDispatchToProps = (dispatch) => ({
  getGradeMasterData: () => dispatch(AddGradeActions.getGradeMasterData()),
  editSchoolInformation: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.editSchoolInformation(ownerId, schoolId, data)),
  updatedSchoolMaster: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.updatedSchoolMaster(ownerId, schoolId, data))
}
)
const mapStateToProps = (state) => {
  return {
    gradeMasterData: state.gradeInformation.gradeList,
    activeSchool: state.schoolInformation.activeSchool,
    updateSchoolinformationInProgress: state.schoolInformation.updateSchoolinformationInProgress

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withAppShell(AddGradeContainer))